import ContentStatusBadge from 'components/badge/ContentStatusBadge';
import ContentTypeBadge from 'components/badge/ContentTypeBadge';
import { AppHelper } from 'helpers/appHelper';
import { ContentHelper } from 'helpers/contentHelper';
import { NavLink } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { AcctState } from 'stores/atoms/acctState';

/**
 *　ホーム画面 直近のコンテンツレポートコンポーネント
 */
export default function WsIndexContentsPublished(): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 型定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const [acctState] = useRecoilState(AcctState);

  /* ----------------------------------------------------------------------- */
  /* ライフサイクル関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      <section className="section-report">
        <div className="container">
          <div className="box-common">
            <h3 className="title-with-icon">
              <img
                src="/img/icon/pie-chart.svg"
                alt="直近のコンテンツレポート"
                className="icon-pie-chart"
              />
              直近のコンテンツレポート
            </h3>

            <div className="table-responsive">
              <table className="table table-top-gray">
                <thead>
                  <tr>
                    <th className="col-1">コンテンツタイトル</th>
                    <th className="col-2">参加数</th>
                    <th className="col-3">獲得リスト数</th>
                    <th className="col-4">獲得率</th>
                    <th className="col-5">完了率</th>
                    <th className="col-6 text-center">形式</th>
                    <th className="col-6 text-center">ステータス</th>
                  </tr>
                </thead>
                <tbody className="ws-index">
                  {acctState.activeContent?.published.map(content => {
                    return (
                      <tr key={`ws-index-quizzes-published-${content.id}`}>
                        <th>
                          <div className="d-flex d-flex-table">
                            <div className="flex-shrink-0 flex-img">
                              <img
                                src={AppHelper.getContentImageUrl(content.imageKey)}
                                className="img-fluid"
                              />
                            </div>
                            <div className="flex-grow-1 flex-text">
                              <NavLink
                                to={`/ws/${
                                  acctState.company.cd
                                }/report/${ContentHelper.getContentsTypeStr(
                                  content.contentsTypeDiv
                                )}/${content.cd}`}
                                className="detail hover quiz-title"
                              >
                                {content.title}
                              </NavLink>
                              <p className="date">
                                {AppHelper.formatTimeToDate(
                                  content.createdAt,
                                  'yyyy年M月dd日 h:mm a'
                                )}
                              </p>
                            </div>
                          </div>
                        </th>
                        {/* 参加数 */}
                        <td>{AppHelper.formatNumberToCurrency(content.participatedCount)}</td>
                        {/* 獲得リスト数 */}
                        <td>{AppHelper.formatNumberToCurrency(content.mailAddressCount)}</td>
                        {/* 獲得率 */}
                        <td>
                          {`${AppHelper.formatRateToPercent(content.mailAddressAcquisitionRate)}%`}
                        </td>
                        {/* 完了率 */}
                        <td>{`${AppHelper.formatRateToPercent(content.answeredRate)}%`}</td>
                        {/* 形式 */}
                        <td className="text-center">
                          <ContentTypeBadge contentsTypeDiv={content.contentsTypeDiv} />
                        </td>
                        {/* ステータス */}
                        <td className="text-center">
                          <ContentStatusBadge
                            statusDiv={content.statusDiv}
                            contentsTypeDiv={content.contentsTypeDiv}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className="text-center">
              <NavLink
                to={`/ws/${acctState.company.cd}/report/search`}
                className="btn btn-grayish-blue"
              >
                レポート一覧
              </NavLink>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
